import React from 'react';
import { connect } from 'react-redux';
import { TransferMonitor as TransferMonitorImport } from '../../PaymentDirector/TransferMonitor/TransferMonitor';
import {
  SessionTransfer as SessionTransferImport,
  SessionTransferOwnProps,
} from '../SessionTransfer/SessionTransfer';
import { AppState, ConnectedPropsWithoutDispatch } from '../../../../../stores/redux-store';

type SessionTransferWrapperProps = PropsFromRedux & {
  TransferMonitor?: React.ComponentType;
  SessionTransfer?: React.ComponentType<SessionTransferOwnProps>;
};

export const SessionTransferWrapperPresenter: React.FC<SessionTransferWrapperProps> = ({
  transfer,
  TransferMonitor = TransferMonitorImport,
  SessionTransfer = SessionTransferImport,
}: SessionTransferWrapperProps) => {
  if (!transfer) {
    return <SessionTransfer />;
  }

  return <TransferMonitor />;
};

const mapStateToProps = (state: AppState) => {
  return {
    transfer: state.transfer.data,
  };
};

const connector = connect(mapStateToProps);

type PropsFromRedux = ConnectedPropsWithoutDispatch<typeof connector>;

export const SessionTransferWrapper = connector(SessionTransferWrapperPresenter);
